import { host, privateClient } from '.';
import getPaginationHeaders from '../utils/get-pagination-headers';

const path = '/tce';

const getBaseUrl = () => `${host}${path}`;

async function CriaTermoDeCompromisso(dados) {
	return await privateClient({
		path: `${path}`,
		params: {
			method: 'POST',
			body: JSON.stringify(dados),
		},
	});
}

async function ConsultaTermoDeCompromissoPeloRegistro(registro) {
	return await privateClient({
		path: `${path}/${registro}`,
	});
}

async function validaTermoDeCompromissoPeloRegistro(registro) {
	return await privateClient({
		path: `${path}/${registro}/validacao`,
		params: {
			method: 'PUT',
		},
	});
}

async function ListaTermosDeCompromisso(pagination) {
	return await privateClient({
		path: `${path}`,
		headers: getPaginationHeaders(pagination, { defaultPageSize: 80 }),
	});
}

const termosDeCompromisso = {
	getBaseUrl,
	CriaTermoDeCompromisso,
	ConsultaTermoDeCompromissoPeloRegistro,
	ListaTermosDeCompromisso,
	validaTermoDeCompromissoPeloRegistro,
};

export default termosDeCompromisso;
